// extracted by mini-css-extract-plugin
export var container = "FensterTurenWidget-module--container--36be3";
export var question = "FensterTurenWidget-module--question--2Oge4";
export var buttonsBlock = "FensterTurenWidget-module--buttonsBlock--gsCFd";
export var personalInformationContainer = "FensterTurenWidget-module--personalInformationContainer--33FRP";
export var fullWidth = "FensterTurenWidget-module--fullWidth--1tpqF";
export var description = "FensterTurenWidget-module--description--1WgsL";